'use client';
import { Container, SimpleGrid } from '@chakra-ui/react';
import React from 'react';

// import required modules
import DiscoverySection from '@/app/_components/discovery/DiscoverySection';
import TitleDescBlock from '@/app/_components/title-desc-block/TitleDescBlock';
import { getImageLink } from '@/services/link.service';
import { CallToAction } from '@/types/home/home.types';

import Styles from './FleetSolutionsTabs.module.scss';

const AdvantageProgram = ({
  data: { blocks, footer_call_to_action, footer_call_to_action_image },
}: {
  data: {
    blocks: { title: string; text: string }[];
    footer_call_to_action: CallToAction;
    footer_call_to_action_image: string;
  };
}) => {
  return (
    <>
      <Container
        className={Styles.fleetTabPanelVerticalContent}
        maxW={1280}
        w={'100%'}
        marginX={'auto'}
        marginBottom={'100px'}
        paddingX={{ base: 6 }}
      >
        <SimpleGrid
          columns={[1, 1, 2, 3]}
          gap={'56px'}
          justifyContent={'center'}
          alignContent={'center'}
          paddingTop={{ md: 14 }}
          paddingBottom={14}
        >
          {blocks?.map((item) => {
            return <TitleDescBlock {...item} key={item.title} />;
          })}
        </SimpleGrid>
      </Container>
      <DiscoverySection
        footer_call_to_action={footer_call_to_action ?? null}
        footer_call_to_action_image={getImageLink(footer_call_to_action_image)}
      />
    </>
  );
};

export default AdvantageProgram;
